import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Label, Input } from 'reactstrap';
import CanalSelect from "./CanalSelect.js"

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import DetailEmpresas from "../../clientes/Empresas/Detail.js"
import CreateLTE from "../../clientes/Responsables/Create.js"

class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            empresa_id: null,
            canal_id: null,
            departamento_id: null,
            ltp_id: null,
            lte_id: null,

            impacta_pais: "",
            impacta_provincia: "",
            impacta_ciudad: "",
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    resetState() {
        this.setState({
            empresa_id: null,
            canal_id: null,
            departamento_id: null,
            departamentopadre_id: null,
            ltp_id: null,
            lte_id: null,

            impacta_pais: "",
            impacta_provincia: "",
            impacta_ciudad: "",
        })
    }

    setSelects(data) {
        this.setState({
            departamento_id: data.departamentointerno_id,
            departamentopadre_id: data.departamentointernopadre_id,
            empresa_id: data.empresa_id,
            canal_id: data.canal_id,
            ltp_id: data.ltp_id,
            lte_id: data.lte_id,

            impacta_pais: data.impacta_pais || " ",
            impacta_provincia: data.impacta_provincia,
            impacta_ciudad: data.impacta_ciudad,
        });
    }

    render() {
        const {
            impacta_pais,
            impacta_provincia,
            impacta_ciudad,
        } = this.state

        return (
            <ParadigmaModal
                getUrl={api.proyectos.solicitudes.edit}
                postUrl={api.proyectos.solicitudes.edit}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"La Solicitud ha sido editada con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Asignar Líderes"}
                buttonTitle={"Asignar Líderes"}
                buttonIcon={"fa fa-user fa-lg"}
                className={"ui-modal-dialog ui-modal-lg"}
                notAllowedMessage={"La Solicitud no puede ser editada en esta etapa porque ya fue avanzada."}

                saveButton={true}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetState()}
            >
                <div className="ui-form">
                    <div className="ui-section-grid">
                        <section className="ui-section-block">
                            <p className="ui-section-label">Identificación</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Grupo</Label>
                                    <ParadigmaAsyncSeeker disabled={true} fieldName={""}
                                        url={api.usuarios.grupos.select} value={this.state.departamentopadre_id} />
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Subgrupo</Label>
                                    <ParadigmaAsyncSeeker disabled={true} fieldName={"departamentointerno_id"}
                                        url={api.usuarios.subgrupos.select} value={this.state.departamento_id} />
                                </div>
                            </div>
                            <div className="ui-row-2">
                                <div className="ui-field">
                                    <Label>Código</Label>
                                    <Input disabled={true} type="text" name={"codigo"} />
                                </div>
                            </div>
                        </section>

                        <section className="ui-section-block">
                            <p className="ui-section-label">Datos principales</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Título</Label>
                                    <Input disabled={true} type="text" name={"nombre"} />
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Forma de Contacto</Label>
                                    <CanalSelect value={this.state.canal_id} disabled={true} />
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Empresa/Organización</Label>
                                    <ParadigmaAsyncSeeker Detail={DetailEmpresas} fieldName={"empresa_id"}
                                        url={api.clientes.empresas.select} value={this.state.empresa_id} disabled={true} />
                                </div>
                            </div>
                        </section>

                        <section className="ui-section-block">
                            <p className="ui-section-label">Localización</p>
                            {impacta_pais &&
                                <div className="ui-row-1">
                                    <div className="ui-field">
                                        <Label>País</Label>
                                        <Input disabled={true} type="text" name={"impacta_pais"} value={impacta_pais} />
                                    </div>
                                </div>
                            }
                            {impacta_provincia &&
                                <div className="ui-row-2">
                                    <div className="ui-field">
                                        <Label>Provincia</Label>
                                        <Input disabled={true} type="text" name={"impacta_provincia"} value={impacta_provincia} />
                                    </div>
                                    {impacta_ciudad &&
                                        <div className="ui-field">
                                            <Label>Ciudad</Label>
                                            <Input disabled={true} type="text" name={"impacta_ciudad"} value={impacta_ciudad} />
                                        </div>
                                    }
                                </div>
                            }
                        </section>

                        <section className="ui-section-block">
                            <p className="ui-section-label">Responsables</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Líder Técnico Proyecto</Label>
                                    <ParadigmaAsyncSeeker fieldName={"ltp_id"}
                                        url={api.usuarios.usuarios.select} value={this.state.ltp_id} />
                                </div>
                            </div>
                            {this.state.empresa_id &&
                                <div className="ui-row-1">
                                    <div className="ui-field">
                                        <Label>Líder Técnico Empresa</Label>
                                        <ParadigmaAsyncSeeker Create={CreateLTE} fieldName={"lte_id"} nombreField={"fullname"}
                                            url={api.clientes.responsables.select + "?tipo=1&empresa_id=" + this.state.empresa_id} value={this.state.lte_id} />
                                    </div>
                                </div>
                            }
                        </section>

                        <section className="ui-section-block ui-section-span-2 ui-section-compact">
                            <p className="ui-section-label">Observaciones</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Observaciones</Label>
                                    <Input disabled={true} type="textarea" rows={5} name={"observaciones"} />
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento1/Asignar.js